import StPetersburgHeroSection from "./components/HeroSection";
import StPetersburgStickyNav from "./components/StickyNav";
import StPetersburgProcessingTimeSection from "./components/ProcessingTimeSection";
import StPetersburgServicesSection from "./components/ServicesSection";
import StPetersburgLocalAreaSection from "./components/LocalAreaSection";
import StPetersburgTravelTimingSection from "./components/TravelTimingSection";
import StPetersburgDestinationsSection from "./components/DestinationsSection";
import StPetersburgTestimonialsSection from "./components/TestimonialsSection";
import StPetersburgAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import StPetersburgComparisonSection from "./components/ComparisonSection";
import StPetersburgMistakesSection from "./components/MistakesSection";
import StPetersburgHowItWorksSection from "./components/HowItWorksSection";
import StPetersburgFAQSection, { faqs } from "./components/FAQSection";
import StPetersburgHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import StPetersburgFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function StPetersburgPage() {
  return (
    <div>
      <CitySEOHead
        city="St. Petersburg"
        state="Florida"
        stateAbbr="FL"
        route="/cities/st-petersburg"
        title="Emergency Passport St. Petersburg, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in St. Petersburg, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Pinellas County travelers, Tampa Bay cruise passengers, and art district visitors."
        ogTitle="Emergency Passport St. Petersburg, FL — Expedited & Fast Passport Service | Fast Passport Center"
        ogDescription="Emergency and expedited passport services in St. Petersburg, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Pinellas County travelers, Tampa Bay cruise passengers, and art district visitors."
        twitterTitle="Emergency Passport St. Petersburg, FL — Expedited & Fast Passport Service | Fast Passport Center"
        twitterDescription="Emergency and expedited passport services in St. Petersburg, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Pinellas County travelers, Tampa Bay cruise passengers, and art district visitors."
        keywords="expedited passport St. Petersburg, emergency passport St. Petersburg FL, same day passport St. Petersburg, fast passport Florida, passport renewal St. Petersburg, St. Petersburg passport courier"
        geoPlacename="St. Petersburg, Florida"
        geoPosition="27.7676;-82.6403"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
      />
      <StPetersburgHeroSection />
      <StPetersburgStickyNav />
      <StPetersburgProcessingTimeSection />
      <StPetersburgLocalAreaSection />
      <StPetersburgServicesSection />
      <StPetersburgTravelTimingSection />
      <StPetersburgDestinationsSection />
      <StPetersburgTestimonialsSection />
      <StPetersburgAcceptanceFacilitiesSection />
      <StPetersburgComparisonSection />
      <StPetersburgMistakesSection />
      <StPetersburgHowItWorksSection />
      <StPetersburgFAQSection />
      <StPetersburgHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/st-petersburg" state="FL" />
      <StPetersburgFinalCTA />
    </div>
  );
}